import { Paper, SvgIcon, SxProps } from '@mui/material'
import { FC } from 'react'

type Props = {
  // eslint-disable-next-line react/require-default-props
  sx?: SxProps
}

const Bell: FC<Props> = ({ sx = {} }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '100%',
        width: '32px',
        height: '32px',
        display: 'grid',
        placeItems: 'center',
        ...sx
      }}>
      <SvgIcon fontSize='small'>
        <svg
          width='16'
          height='17'
          viewBox='0 0 16 17'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M1.96633 13.547H14.0368C14.7526 13.547 15.1867 13.1814 15.1867 12.6255C15.1867 11.864 14.41 11.1786 13.755 10.5008C13.2524 9.97539 13.1153 8.89397 13.0544 8.01817C13.0011 5.09387 12.2243 3.0834 10.1986 2.35232C9.90923 1.3547 9.12486 0.570312 7.99776 0.570312C6.87828 0.570312 6.08628 1.3547 5.80451 2.35232C3.7788 3.0834 3.00203 5.09387 2.94872 8.01817C2.8878 8.89397 2.75072 9.97539 2.2481 10.5008C1.58556 11.1786 0.816406 11.864 0.816406 12.6255C0.816406 13.1814 1.24287 13.547 1.96633 13.547ZM7.99776 16.6008C9.29239 16.6008 10.2367 15.6564 10.3357 14.5903H5.66743C5.76643 15.6564 6.71074 16.6008 7.99776 16.6008Z'
            fill='#1C1C1E'
          />
        </svg>
      </SvgIcon>
    </Paper>
  )
}

export default Bell
